export interface Price {
  currency: string;
  value: number;
  discount: number;
  vat_percentage: number;
  volume: number;
}

export class Price implements Price {}
